import 'reflect-metadata';

import { animated, useSpring } from '@react-spring/web';
import { injectable } from 'inversify';
import React from 'react';

import { useApiRequestWrapper } from '../hooks/useApiRequestWrapper';
import { TUseToggleComponentHook } from '../types';

@injectable()
export class ReactHookFactory {
  public composeUseApiRequestWrapper(): typeof useApiRequestWrapper {
    return useApiRequestWrapper;
  }

  public composeUseToggleComponentHook(payload: {
    ReactComponent: React.FC<{
      isToggleActive: boolean;
      toggleTenantSwitcherComponent: () => void;
    }>;
  }): TUseToggleComponentHook {
    const { ReactComponent } = payload;

    return () => {
      const [isOpen, setIsOpen] = React.useState<boolean>(false);

      const mainDivStyles = useSpring({
        bottom: isOpen ? 72 : -186,
        left: 8,
        margin: 0,
        opacity: isOpen ? 1 : 0,
        padding: 0,
        zIndex: 9999,
      });

      const handleCloseOnClick = () => {
        setIsOpen(false);
      };

      const handleToggleComponentOnClick = () => {
        setIsOpen((prevState) => !prevState);
      };

      const ReactComponentWrapper = () => (
        <animated.article
          style={{
            ...mainDivStyles,
            position: 'fixed',
          }}
        >
          <animated.div
            style={{
              margin: 0,
              padding: 0,
              position: 'relative',
              zIndex: 9998,
            }}
          >
            <ReactComponent
              toggleTenantSwitcherComponent={handleCloseOnClick}
              isToggleActive={isOpen}
            />
          </animated.div>
          <animated.div
            onClick={handleCloseOnClick}
            role={'button'}
            aria-label={'close toggle component'}
            style={{
              background: 'transparent',
              bottom: 0,
              height: isOpen ? window.innerHeight : 0,
              left: 0,
              opacity: isOpen ? 1 : 0,
              position: 'fixed',
              right: 0,
              top: 0,
              width: isOpen ? window.innerWidth : 0,
              zIndex: 9997,
            }}
          />
        </animated.article>
      );

      return [ReactComponentWrapper, handleToggleComponentOnClick];
    };
  }
}
